import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-family: "Poppins", sans-serif;
  background-color: ${(props) =>
    props.abaSelected === 3 ? "rgba(var(--black_rgb), 0.05)" : "white"};

  border: ${(props) =>
    props.abaSelected === 3
      ? "1px solid rgba(var(--black_rgb), 0.05)"
      : "1px solid rgba(var(--black_rgb), 0.1)"};

  h4 {
    margin: 0rem;

    svg {
      font-size: 1rem;
      margin-bottom: -0.17rem;
    }
  }

  .tag {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }

  .tag p {
    display: inline-block;
    padding: 0.3rem 0.5rem;
    font-size: 0.7rem;
    border-radius: var(--border-radius);
    text-align: center;
    background-color: ${(props) =>
      props.finished ? "gray" : "var(--primary2)"};
    color: var(--white);
    margin: 0;
  }

  .tag-whatsapp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }

  .tag-whatsapp p {
    display: inline-block;
    padding: 0.3rem 0.5rem;
    font-size: 0.7rem;
    border-radius: var(--border-radius);
    text-align: center;
    background-color: green;
    color: var(--white);
    margin: 0;
  }

  .div__options {
    text-align: center;

    .button_icon {
      border-radius: 50%;
      width: 35px;
      margin: 0.2rem;
      height: 35px;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      cursor: pointer;
      border: 0;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);

      svg {
        font-size: 1.2rem;
        color: rgba(var(--black_rgb), 0.3);
        margin-bottom: -0.2rem;
      }

      :hover {
        border: 2px solid var(--primary2);
        svg {
          color: var(--primary2);
        }
      }
    }

    .button_delete {
      :hover {
        border: 2px solid var(--delete);
        svg {
          color: var(--delete);
        }
      }
    }
  }

  .div__name {
    padding: 1rem;
    flex: 2;
    text-align: center;
    display: flex;
    flex-direction: column;

    h4 {
      color: ${(props) =>
        props.abaSelected === 1
          ? "var(--primary2)"
          : props.abaSelected === 2
          ? "var(--waitingColor)"
          : "var(--delete)"};
    }
    span {
      color: rgba(0, 0, 0, 0.7);
    }
  }

  .div__power {
    padding: 1rem;
    flex: 1;
    display: flex;
    flex-direction: column;

    h4 {
      margin: 0.5rem;
    }

    .div__sub_power {
      display: flex;
      flex-direction: column;
      span {
        font-size: 12px;
        text-transform: uppercase;
        font-weight: 300;
      }
      p {
        margin: auto;
      }
    }
  }

  .button_payment {
      border-radius: var(--border-radius);
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgba(var(--black_rgb), 0.5);
      padding-right: 0.75rem;
      border: 0;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);

      svg {
        font-size: 1.2rem;
        color: rgba(var(--black_rgb), 0.3);
        margin-bottom: 0rem;
      }

      :hover {
        border: 2px solid var(--primary2);
        color: var(--primary2);
        svg {
          color: var(--primary2);
        }
      }
    }

    .button_cancel_payment {
      border: 0;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);

      :hover {
        /* box-shadow: 0px 0px 5px rgba(var(--primary2_rgb), 1); */
        border: 2px solid var(--delete) !important;
        color: var(--delete) !important;
        svg {
          color: var(--delete) !important;
        }
      }
    }

    button {
      border-radius: 50%;
      margin: 0.2rem;
      height: 35px;
      justify-content: center;
      align-items: center;
      border: 0px solid rgba(var(--black_rgb), 0.3);
      background-color: transparent;
      cursor: pointer;
      border: 0;
      box-shadow: 0.0625rem 0.0625rem 0.3125rem rgba(0, 0, 0, 0.3);

      svg {
        font-size: 1.2rem;
        color: rgba(var(--black_rgb), 0.3);
        margin-bottom: -0.2rem;
      }

      :hover {
        border: 2px solid var(--primary2);
        svg {
          color: var(--primary2);
        }
      }
    }

  @media screen and (max-width: 675px) {
    flex-direction: column;
    margin-bottom: 1rem;

    .div__name {
      padding: 2rem;
      padding-bottom: 0rem;
      width: 100%;
      flex: 2;
      text-align: center;
      display: flex;
      flex-direction: column;
      span {
        color: rgba(0, 0, 0, 0.7);
      }
    }
  }

   @media screen and (max-width: 675px) {
    flex-direction: column;
    margin-bottom: 1rem;

    .button_payment {
      margin: 0.5rem auto !important;
    }
  }
`;

